import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options }) {
    return (
        <>
            {options.map(option => (
                <button 
                class="flex text-[11px] md:text-[15px] p-3 text-left w-full hover:bg-black-10 hover:text-black hover:duration-200"
                role="menuitem" 
                tabindex="-1" 
                data-headlessui-state=""
                key={option.value} value={option.value}
                onClick={onChange}
                >
                    {option.label}
                </button>
            ))}
        </>
    )
}